import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=6d7be552"
import script from "./Telegram.vue?vue&type=script&lang=js"
export * from "./Telegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7be552')) {
      api.createRecord('6d7be552', component.options)
    } else {
      api.reload('6d7be552', component.options)
    }
    module.hot.accept("./Telegram.vue?vue&type=template&id=6d7be552", function () {
      api.rerender('6d7be552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/Telegram.vue"
export default component.exports